import { Button, Icon, PrivateLock, Row, Typography } from '@viewup/ui';
import { PostCampaignCard, PostCampaignCardStatus } from 'app/viewing/_entities/post';

type PrivateCardProps = {
  point: number;
};
export const PrivateCard = (props: PrivateCardProps) => {
  return (
    <PostCampaignCard campaignUuid='uuid' name=''>
      <PostCampaignCard.Title>
        <Row alignItems='center' gap={8}>
          <Icon color='icon.disabled' size='XS' source={PrivateLock} />
          <Typography color='text.primary' fontType='body2.medium'>
            프라이빗 캠페인 입니다.
          </Typography>
        </Row>
      </PostCampaignCard.Title>
      <PostCampaignCard.Point point={props.point} />
      <PostCampaignCard.Progress status={PostCampaignCardStatus.BEFORE_APPLICATION} />
      <PostCampaignCard.BottomContent>
        <Button css={{ width: '100%' }} size='M'>
          신청하기
        </Button>
      </PostCampaignCard.BottomContent>
    </PostCampaignCard>
  );
};
